module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '/**\n * @module Configuration\n */\n//  Created by scottrohrer on 10/7/16.\ndefine(function () {\n    var instance = null;\n    /**\n     * @class Configuration\n     */\n    function Configuration() {\n        this.userScaleFactor = 1.0;\n        this.showVesselStats = true;\n        // add other things that are currently being handled in a less efficient way\n    }\n    Configuration.getInstance = function() {\n        if(instance === null) {\n            instance = new Configuration();\n        }\n        return instance;\n    };\n    return Configuration.getInstance();\n});\n';

}
return __p
}